import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import BaseIngredientLanguageInput from 'components/desktop/BaseIngredient/LanguageInput/BaseIngredientLanguageInput';
import LanguageSwitch from 'components/desktop/_general/LanguageSwitch/LanguageSwitch';
import useCultureCode from 'hooks/redux/useCultureCode';

export const BaseIngredientNameInputs = ({
	state,
	handlers,
}: BaseIngredientTabProps): JSX.Element => {
	const cultureCode: string = useCultureCode();

	return (
		<LanguageSwitch
			handleSelectLanguage={(_e: any, selectedLanguage: string) => {
				handlers.setSelectedCultureCode(selectedLanguage);
			}}
			selectedLanguage={state.selectedCultureCode}
			translatable={true}
			onTranslateClick={() =>
				handlers.translateAndSetName({
					fromCultureCode: cultureCode,
					text: state.name[cultureCode],
				})
			}
			entryLanguage={cultureCode}
			content={
				<BaseIngredientLanguageInput
					onTranslateClick={() =>
						handlers.translateAndSetName({
							fromCultureCode: cultureCode,
							text: state.name[cultureCode],
						})
					}
					text={state.name[state.selectedCultureCode] ?? ''}
					selectedLanguage={state.selectedCultureCode}
					handleValueChange={handlers.setName}
				/>
			}
		/>
	);
};
